<section
  class="for-company-section"
  [class.is-rtl]="currentLanguage == 'ar'"
  [attr.dir]="currentLanguage == 'ar' ? 'rtl' : 'ltr'"
>
  <div class="atw-container">

    <div class="section-title for-company-title">
      <span>
        <b>{{ 'atw.companies.sectionNumber' | transloco }}</b>
      </span>

      <div>
        <h2>{{ 'atw.companies.title' | transloco }}</h2>
        <p>{{ 'atw.companies.subtitle' | transloco }}</p>
      </div>
    </div>

    <div class="apply-card for-company-card">
      <div class="for-company-grid">

        <!-- Text Side -->
        <div class="company-content">
          <div class="hero-badge company-badge">
            <span>{{ 'atw.companies.badgeNumber' | transloco }}</span>
            {{ 'atw.companies.badgeTitle' | transloco }}
          </div>

          <h3>
            {{ 'atw.companies.headingLine1' | transloco }}
            <strong>{{ 'atw.companies.headingStrong' | transloco }}</strong>
            {{ 'atw.companies.headingLine2' | transloco }}
          </h3>

          <p>
            {{ 'atw.companies.description' | transloco }}
          </p>

          <div class="company-features">
            <div class="company-feature" *ngFor="let feature of features">
              <img
                class="img-m"
                [src]="feature.iconImg"
                [alt]="feature.title | transloco"
              />

              <div>
                <strong>{{ feature.title | transloco }}</strong>
                <small>{{ feature.text | transloco }}</small>
              </div>
            </div>
          </div>

          <div class="hero-actions company-actions">
            <a routerLink="/iamhiring" class="primary-action">
              {{ 'header.Register' | transloco }}


            </a>

            <a routerLink="/create-job" class="secondary-action">
              {{ 'header.addjob' | transloco }}

              <img
                class="img-s"
                src="/assets/as/10.webp"
                alt="add job"
              />
            </a>
          </div>
        </div>

        <!-- Visual Side -->
        <div class="company-visual">
          <div class="dots dots-right company-dots"></div>

          <div class="company-main-card rightborder">
            <div class="company-icon-big">
              <img
                class="img-l"
                src="/assets/as/9.webp"
                alt="company"
              />
            </div>

            <h4>{{ 'atw.companies.visualTitle' | transloco }}</h4>
            <p>{{ 'atw.companies.visualText' | transloco }}</p>

            <div class="company-steps">
              <div>
                <span>01</span>
                <strong>{{ 'atw.companies.step1' | transloco }}</strong>
              </div>

              <div>
                <span>02</span>
                <strong>{{ 'atw.companies.step2' | transloco }}</strong>
              </div>

              <div>
                <span>03</span>
                <strong>{{ 'atw.companies.step3' | transloco }}</strong>
              </div>
            </div>
          </div>

          <div class="floating-card company-floating company-floating-top">
            <img
              class="img-m"
              src="/assets/as/12.webp"
              alt="job request"
            />

            <div>
              <strong>{{ 'atw.companies.floatJobTitle' | transloco }}</strong>
              <small>{{ 'atw.companies.floatJobText' | transloco }}</small>
            </div>
          </div>

          <div class="floating-card company-floating company-floating-bottom">
            <img
              class="img-m"
              src="/assets/as/27.webp"
              alt="verified"
            />

            <div>
              <strong>{{ 'atw.companies.floatVerifiedTitle' | transloco }}</strong>
              <small>{{ 'atw.companies.floatVerifiedText' | transloco }}</small>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</section>